export default {
    getFontSize(states) {
        return states.fontSize
    },
    getRouteName(states) {
        return states.routeName
    },
    getRemainTime(states) {
        return states.remainTime
    },
    getSocketType(states) {
        return states.socketType
    },
    getSocketData(states) {
        return states.socketData
    },
}



// WEBPACK FOOTER //
// ./src/store/anscart/getters.js